// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"deliveryDate___wrapper___3n96z","campaign-info":"deliveryDate___campaign-info___1wWb3"};